// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as React from "react";
import * as Inline from "../../resources/layout-and-structure/Inline.res.js";
import * as JsxRuntime from "react/jsx-runtime";

function toBadge(status) {
  if (status === "TO_PAY") {
    return JsxRuntime.jsx(Badge.make, {
      children: I18n.t("To pay"),
      variation: "warning"
    }, status);
  } else if (status === "DRAFT") {
    return JsxRuntime.jsx(Badge.make, {
      children: I18n.t("Draft"),
      variation: "neutral"
    }, status);
  } else if (status === "NOT_RECEIVED") {
    return JsxRuntime.jsx(Badge.make, {
      children: I18n.t("Not received"),
      variation: "normal"
    }, status);
  } else if (status === "REFUSED") {
    return JsxRuntime.jsx(Badge.make, {
      children: I18n.t("Declined"),
      variation: "danger"
    }, status);
  } else if (status === "FINALIZED") {
    return JsxRuntime.jsx(Badge.make, {
      children: I18n.t("Finalized"),
      variation: "success"
    }, status);
  } else if (status === "ACCEPTED") {
    return JsxRuntime.jsx(Badge.make, {
      children: I18n.t("Accepted"),
      variation: "success"
    }, status);
  } else if (status === "PAID") {
    return JsxRuntime.jsx(Badge.make, {
      children: I18n.t("Paid"),
      variation: "success"
    }, status);
  } else if (status === "RECEIVING") {
    return JsxRuntime.jsx(Badge.make, {
      children: I18n.t("Reception in progress"),
      variation: "information"
    }, status);
  } else if (status === "SENT") {
    return null;
  } else if (status === "RECEIVED") {
    return JsxRuntime.jsx(Badge.make, {
      children: I18n.t("Reception finished"),
      variation: "success"
    }, status);
  } else {
    return JsxRuntime.jsx(Badge.make, {
      children: I18n.t("Archived"),
      variation: "neutral"
    }, status);
  }
}

function OrderStatusBadges(props) {
  return JsxRuntime.jsx(Inline.make, {
    children: props.statuses.map(toBadge),
    space: "small",
    wrap: true
  });
}

let make = React.memo(OrderStatusBadges);

export {
  toBadge,
  make,
}
/* make Not a pure module */
